import {
  CheckCircleOutlined,
  StopOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import * as APITypes from "~/API";
import { useAppTranslation } from "~/hooks/useAppTranslation";

export const PaymentStatusTag = ({
  status,
}: {
  status: APITypes.PaymentStatusType;
}) => {
  const { t } = useAppTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t(status);

  if (status === APITypes.PaymentStatusType.Complete) {
    color = "green";
    icon = <CheckCircleOutlined />;
  }
  if (status === APITypes.PaymentStatusType.Failed) {
    color = "red";
    icon = <StopOutlined />;
  }
  if (status === APITypes.PaymentStatusType.Processing) {
    color = "blue";
    icon = <SyncOutlined />;
  }
  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
